'use strict';


class ImagePlaceholderCache {
  constructor() {
    this.cache = {};
    this.canvas = document.createElement('canvas');
  }

  getDataURLForSize({ width, height }: size) {
    const key = `${width}:${height}`;
    if (!this.cache[key]) {
      this.canvas.width = width;
      this.canvas.height = height;
      this.cache[key] = this.canvas.toDataURL();
    }

    return this.cache[key];
  }
}

module.exports = ImagePlaceholderCache;



/** WEBPACK FOOTER **
 ** ./utils/ImagePlaceholderCache.js
 **/